<template>
  <ckeditor v-model="data.description" :editor="editor" :config="editorConfig" @input="updateField" @ready="onEditorReady" />
</template>
<script>
import { reactive } from 'vue'
import ClassicEditor from '../Plugin/CKEditor/ckeditor.js'

export default {
  name: 'EmailEditor',
  props: {
    emailMessageModal: {
      type: String,
      default: '',
    },
  },
  emits: ['change-email'],
  setup(props) {
    //....
    const data = reactive({
      description: props.emailMessageModal,
    })
    return {
      data,
      editor: ClassicEditor,
      editorConfig: {
        // image2_disableResizer: true,
        // disableObjectResizing: true,
        // image_prefillDimensions: false,
        // disallowedContent: 'img{width,height}',
        // extraAllowedContent: 'img[width,height]',
        // image: {
        //   resizeOptions: [],
        // },
        toolbar: {
          items: [
            'heading',
            {
              // This drop-down has the icon disabled and a text label instead.
              label: 'Font',
              icon: false,
              items: [
                'bold',
                'italic',
                'fontSize',
                'fontColor',
                'fontBackgroundColor',
                'underline',
                'strikethrough',
              ],
            },
            {
              // This drop-down has the icon disabled and a text label instead.
              label: 'Format',
              icon: false,
              items: [
                'blockQuote',
                'bulletedList',
                'numberedList',
                'outdent',
                'indent',
              ],
            },
            '|',
            'imageInsert',
            'link',
            '|',
            // 'fontSize',
            // 'horizontalLine',
            'insertTable',
            'mediaEmbed',
            'undo',
            'redo',
            'sourceEditing',
          ],
        },
        language: 'en',
        table: {
          contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells'],
        },
        mediaEmbed: {
          previewsInData: false,
          removeProviders: ['loom', 'vimeo'],
        },
        removePlugins: ['MediaEmbedToolbar'],
        simpleUpload: {
          // The URL that the images are uploaded to.
          uploadUrl: '/emailMass/uploadCKImage',
        },
        // headers: {
        //   'X-CSRF-TOKEN': 'CSFR-Token',
        //   Authorization: 'Bearer <JSON Web Token>'
        // },
        htmlSupport: {
          allow: [
            {
              name: /.*/,
              attributes: true,
              classes: true,
              styles: true
            }
          ]
        },
      },
    }
  },
  methods: {
    updateField: function () {
      this.$emit('change-email', String(this.data.description))
    },
    onEditorReady(editor) {
      this.editor = editor
    },
    insertField(token) {
      this.editor.model.change((writer) => {
        writer.insertText(token, this.editor.model.document.selection.getFirstPosition())
      })
      this.editor.focus()
    },
  },
}
</script>
<style>
.ck-editor__editable {
  min-height: 120px;
  line-height: 1em;
}
.ck-editor__editable_inline {
    padding: 0 30px !important;
}
.ck-content p {
  /* line-height: 1.6 !important; */
  margin-bottom: 1em;
}
.ck-content img {
  max-width: 100% !important;
  width: auto !important;
  height: auto !important;
  width: unset;
  height: unset;
  display: block;
}
/* Loom video container styles */
.ck-content .media {
  margin: 1em 0;
  display: block;
  width: 100%;
  max-width: 100%;
  clear: both;
}

.ck-content .loom-container {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  width: 100% !important;
  max-width: 100% !important;
}

.ck-content .loom-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
  max-width: 100%;
}

/* Email-specific styles */
.ck-content {
  width: 100% !important;
  max-width: 100% !important;
}

.ck-content figure {
  width: 100% !important;
  max-width: 100% !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
}

/* Ensure media embeds maintain full width in email clients */
.ck-content figure.media {
  width: 100% !important;
  max-width: 100% !important;
  margin: 1em 0 !important;
}

/* Force full width on email clients that try to restrict width */
[data-oembed-url] {
  width: 100% !important;
  max-width: 100% !important;
}

/* Clean up media wrapper styles */
.ck-media__wrapper {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  max-width: 100%;
  width: 100% !important;
}

.ck-media__wrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  max-width: 100%;
}

/* Add these new styles */
.loom-video-container {
  margin: 1em 0;
  width: 100%;
}

.loom-video-container table {
  width: 100% !important;
  margin: 0 !important;
}

.loom-video-container img {
  max-width: 100% !important;
  height: auto !important;
}
</style>
